import { useEffect, useState, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FAB from "@/components/FAB";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Approach from "@/pages/Approach";
import Industries from "@/pages/Industries";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";

export const LenisContext = createContext(null);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useContext(LenisContext);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

function App() {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const instance = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(instance);
    let rafId;
    const raf = (time) => {
      instance.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      instance.destroy();
    };
  }, []);

  return (
    <div className="App">
      <LenisContext.Provider value={lenis}>
        <BrowserRouter>
          <a href="#main" className="skip-link">Skip to content</a>
          <ScrollToTop />
          <Header />
          <main id="main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/approach" element={<Approach />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
            </Routes>
          </main>
          <Footer />
          <FAB />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </LenisContext.Provider>
    </div>
  );
}

export default App;
